import $ from 'jquery';
import { fdsReset, fdsShowFieldError } from 'modals';

function search($modal) {
    const $streetName = $('#didNotFindStreetname');
    const streetName = $streetName.val();
    const $postalCode = $('#didNotFindPostalCode');
    const postalCode = $postalCode.val();
    const $authority = $('#didNotFindAuthority');
    const authority = $authority.val();

    if (streetName && postalCode && authority !== '0') {
        const site = {
            'authority': authority,
            'streetName': streetName,
            'postCodeIdentifier': postalCode,
            'searchType': 'didnotfind'
        };
        addSection(site);
    } else {
        if (!streetName) {
            fdsShowFieldError($streetName, "Udfyld venligst feltet");
        }
        if (!postalCode) {
            fdsShowFieldError($postalCode, "Udfyld venligst feltet");
        }
        if (authority === '0') {
            fdsShowFieldError($authority, "Udfyld venligst feltet");
        }
    }
}

function addSection(data) {
    $('#addSection')
        .val(JSON.stringify(data))
        .prop('disabled', false)
        .closest('form')
        .submit();
}

$(() => {
    const $modal = $('#didNotFindModal');

    $modal.get(0).addEventListener('fds.modal.hidden', () => {
        fdsReset($modal);
    });

    $('#didNotFindModalOK').on('click', () => search($modal));
});
